import Head from 'next/head';
import React from 'react';
import { Query } from 'react-apollo';
import { ParallaxProvider } from 'react-scroll-parallax';
import styled from 'styled-components';
import Breadcrumb from '../../src/components/Breadcrumb';
import { Container } from '../../src/components/Grid';
import Header from '../../src/components/Header';
import { Main, Page, Section } from '../../src/components/Layout';
import Watermark from '../../src/components/Parallax/Watermark';
import { withI18N } from '../../src/hoc/index';
import { media } from '../../src/styles/media';
import getPageByType from '../../src/apollo/graphql/page/getPageByType';
import createContext from '../../src/utils/format/createContext';

const Paragraphe = styled.div`
  max-width: 312px;
  margin: 0 auto;

  h2 {
    font-family: ${({ theme }) => theme.font.brand.primary};
    color: ${({ theme }) => theme.color.brand.primary};
    font-size: ${({ theme }) => theme.font.heading3.fontSize};
    line-height: ${({ theme }) => theme.font.heading3.lineHeight};
  }

  a  {
    text-decoration: underline;
    color: ${props => props.theme.color.brand.primary};
  }

  p,
  ul,
  h3 {
    font-family: ${({ theme }) => theme.font.body.fontFamily};
    color: ${({ theme }) => theme.color.brand.grey};
    font-size: ${({ theme }) => theme.font.body.fontSize};
    line-height: ${({ theme }) => theme.font.body.lineHeight};
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1.8rem;
    text-decoration: underline;
  }

  ul {
    margin-left: 20px;
  }

  ${media.tablet`
    max-width: 998px;
  `};
`;

class Confidentiality extends React.PureComponent {
  render() {
    const { t, i18n } = this.props;

    return (
      <Page confidentiality>
        <Query
          query={getPageByType}
          variables={{
            type: 'confidential'
          }}
          context={createContext(i18n.language)}
        >
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPageByType) {
              const { getPageByType } = data;
              return (
                <div>
                  <Head>
                    <title key="title">Grand Hôtel-Dieu</title>
                  </Head>
                  <Header
                    title={getPageByType.detail.title}
                    image={getPageByType.img_header_desktop}
                    imageMobile={getPageByType.img_header_mobile}
                  />
                  <Main>
                    <Container>
                      <Breadcrumb
                        items={[
                          { href: '/', label: t('common:nav.tabs.home') },
                          { label: getPageByType.detail.title }
                        ]}
                      />
                    </Container>
                    <Section>
                      <Container>
                        <Paragraphe
                          dangerouslySetInnerHTML={{
                            __html: getPageByType.detail.content
                          }}
                        />
                      </Container>
                    </Section>
                  </Main>
                </div>
              );
            }
            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(Confidentiality);
